import { Effect, Redacted } from "effect";
import { workerstationService } from "../../effect/service.ts";
import { privateDependencyFailure } from "../../errors/private-cause.ts";
import type { PlatformAssertionKeyRequest, PlatformAssertionValidationConfig } from "../model.ts";

export const AuthorizationIdentityError = /* @__PURE__ */ (() => {
  class AuthorizationIdentityError extends privateDependencyFailure<AuthorizationIdentityError>()("AuthorizationIdentityError", "authorization identity") {}
  return AuthorizationIdentityError;
})();
export type AuthorizationIdentityError = InstanceType<typeof AuthorizationIdentityError>;
export const authorizationIdentityError = (cause: unknown) => new AuthorizationIdentityError({ cause: Redacted.make(cause) });

export class PlatformAssertionIo extends workerstationService<PlatformAssertionIo, {
  readonly resolveKey: (config: PlatformAssertionValidationConfig, request: PlatformAssertionKeyRequest) => Effect.Effect<CryptoKey | null, AuthorizationIdentityError>;
  readonly verify: (key: CryptoKey, signature: () => Uint8Array<ArrayBuffer>, data: () => Uint8Array<ArrayBuffer>) => Effect.Effect<boolean, AuthorizationIdentityError>;
}>()("Authorization/PlatformAssertionIo") {}
